<template>
  <el-select
    v-model="innerValue"
    v-bind="$attrs"
    :filterable="true"
    :filter-method="handleFilter"
    @change="onChange"
    @visible-change="onVisibleChange"
    @clear="onClear">
    <!-- 关键: 始终为已选项渲染一个隐藏的 el-option, 保证 el-select 能解析出 label
         (因为虚拟滚动只渲染可视的 12 个,选中项很可能不在 DOM 里) -->
    <el-option
      v-if="selectedItem"
      :key="'__selected_' + selectedItem[valueKey]"
      :label="selectedItem[labelKey]"
      :value="selectedItem[valueKey]"
      class="virtual-select-pinned-option" />
    <virtual-list
      class="virtual-select-list"
      :data-key="itemKey"
      :data-sources="filtered"
      :data-component="itemComponent"
      :estimate-size="32"
      :keeps="visibleCount"
      :extra-props="{ labelKey, valueKey }">
    </virtual-list>
  </el-select>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list';

// 单项渲染组件: el-option 替身, 支持 el-select 选中样式
const VirtualOption = {
  name: 'VirtualOption',
  functional: true,
  props: {
    source: { type: Object, required: true },
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'value' }
  },
  render(h, ctx) {
    const { source, labelKey, valueKey } = ctx.props;
    return h('el-option', {
      props: {
        label: source[labelKey],
        value: source[valueKey]
      },
      key: source[valueKey]
    });
  }
};

export default {
  name: 'VirtualSelect',
  components: { VirtualList },
  inheritAttrs: false,
  props: {
    value: { type: [String, Number, Array], default: null },
    options: { type: Array, default: () => [] },
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'value' },
    itemKey: { type: String, default: 'id' },
    /** 单次保留的 DOM 节点数(虚拟窗口高度) */
    visibleCount: { type: Number, default: 12 }
  },
  data() {
    return {
      innerValue: this.value,
      query: '',
      itemComponent: VirtualOption
    };
  },
  computed: {
    filtered() {
      if (!this.query) return this.options;
      const q = this.query.toLowerCase();
      const lk = this.labelKey;
      return this.options.filter(o => {
        const v = o[lk];
        return v != null && String(v).toLowerCase().includes(q);
      });
    },
    selectedItem() {
      if (this.innerValue == null || this.innerValue === '') return null;
      return this.options.find(o => o[this.valueKey] === this.innerValue) || null;
    }
  },
  watch: {
    value(v) { this.innerValue = v; }
  },
  methods: {
    handleFilter(q) { this.query = q || ''; },
    onVisibleChange(v) {
      if (!v) this.query = '';  // 关闭时清空搜索
    },
    onChange(v) { this.$emit('input', v); this.$emit('change', v); },
    onClear() { this.query = ''; }
  }
};
</script>

<style scoped>
/* virtual-list 默认高度撑满,这里限制以适配下拉框 */
.virtual-select-list {
  max-height: 274px;
  overflow-y: auto;
}
/* 隐藏 pinned option(只用于让 el-select 能解析 selected label, 不实际显示在下拉里) */
.virtual-select-pinned-option {
  display: none !important;
}
</style>
